import APIService from '../api.service';

export const List = (params) => {
  return APIService.get(`/v01/banks`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
    },
  });
};

export const Create = (body, config = {}) => {
  return APIService.post(`/v01/banks`, body, config);
};

export const Put = (id, body, config = {}) => {
  return APIService.put(`/v01/banks/${id}`, body, config);
};

export const Delt = (id, config = {}) => {
  return APIService.delete(`/v01/banks/${id}`, config);
};

export const All = () => {
  return APIService.get(`/v01/banks/get/all`);
};

const BankService = {
  List,
  Create,
  Put,
  Delt,
  All
};
export default BankService;
